import React from "react";
import * as PropTypes from "prop-types";
import { populationDatumPropType } from "../../propTypes";
import { formatLogicalCell } from "../../utilities";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { withTranslation } from "react-i18next";
import { translateGridText } from "../../i18n";

const columnDefinitions = (t) => [
    {
        headerName: t("Region code"),
        field: "regionCode",
        width: 150,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("In union?"),
        field: "isInUnion",
        width: 125,
        headerClass: "ag-left-aligned-header",
        cellStyle: { textAlign: "center" },
        valueFormatter: (params) => formatLogicalCell(params.value),
    },
    {
        headerName: t("Age"),
        field: "ageRange",
        width: 125,
        headerClass: "ag-left-aligned-header",
        cellStyle: { textAlign: "center" },
    },
    {
        headerName: t("Year"),
        field: "midYear",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        width: 125,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("Population"),
        field: "population",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        width: 200,
        headerClass: "ag-left-aligned-header",
    },
];

const PopulationDataTable = ({ t, ...rest }) => {
    const rowData = rest.data;
    const columnDefs = columnDefinitions(t);

    return (
        <div className="ag-theme-material">
            <AgGridReact
                domLayout="autoHeight"
                defaultColDef={{ sortable: true, filter: true }}
                pagination={true}
                paginationPageSize={10}
                suppressColumnVirtualisation={true}
                suppressCellFocus={true}
                overlayNoRowsTemplate="<span />"
                getLocaleText={translateGridText}
                rowData={rowData}
                columnDefs={columnDefs}
                rowHeight={30}
                // autoSizeStrategy={{ type: "fitGridWidth" }}
                // onGridReady={(params) => params.columnApi.autoSizeAllColumns()}
            />
        </div>
    );
};

PopulationDataTable.propTypes = {
    data: PropTypes.arrayOf(populationDatumPropType),
};

PopulationDataTable.defaultProps = {
    data: [],
};

export default withTranslation()(PopulationDataTable);
